import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { ViewCell } from '../../ng2-smart-table/components/cell/cell-view-mode/view-cell';
import { Router } from '@angular/router';
import { PermissionService } from '../../../../services/permission.service';


@Component({
  selector: 'app-table-report-schedule',
  template: `<div class="d-flex" style="gap:10px; margin-top:6px;" *ngIf="showScheduleControl">
              <app-ui-switch-text *ngIf ="!saved" style="margin-top:1px;"
                        [labelOff]="''"
                        (change)="onClick()"
                        [checked]="renderValue"
                        [labelOn]="''">
                </app-ui-switch-text>

                <div  *ngIf="(confirmation_status === 0) && !saved && !renderValue && showResendLink">
                   <a class="status-link text-link" href="javascript:void(0)" (click)="onResendClick()"
                     ngbTooltip="Resend Confirmation Link">Resend</a>
                </div>
                </div>
                <span *ngIf="saved"><strong>Unscheduled</strong></span>`,
  styleUrls: ['./table-report-schedule.component.scss']
})
export class TableReportScheduleComponent implements ViewCell, OnInit {

  @Input() value: string | number;
  @Input() rowData: any;

  @Output() clicked: EventEmitter<any> = new EventEmitter();
  @Output() resendclicked: EventEmitter<any> = new EventEmitter();

  renderValue: boolean;
  saved: number;
  confirmation_status: any;
  showScheduleControl: boolean;
  showResendLink: boolean;

  constructor(
    private router: Router,
    private permissionService: PermissionService
  ) {}

  ngOnInit() {
    this.saved = +this.rowData.saved_only;
    this.confirmation_status = +this.rowData.confirm;
    this.renderValue = !!(+this.rowData.schedule_confirm);
    const url = this.router.url;
    const isEmailSavedScheduleReport = url.includes('analytics/saved-schedule-report');
    const isGrcsManageReports = url.includes('grcs/manage-reports');
    const isWaManageReports = url.includes('whatsapp/manage-reports');
    if (isEmailSavedScheduleReport) {
      this.showScheduleControl = this.permissionService.hasPermission('email', 'Reports', 'edit');
      this.showResendLink = this.permissionService.hasPermission('email', 'Reports', 'resend');
    } else if (isGrcsManageReports) {
      this.showScheduleControl = this.permissionService.hasPermission('rcs', 'Reports', 'edit');
      this.showResendLink = true;
    } else if (isWaManageReports) {
      this.showScheduleControl = this.permissionService.hasPermission('whatsapp', 'Reports', 'edit');
      this.showResendLink = true;
    } else {
      this.showScheduleControl = true;
      this.showResendLink = true;
    }
  }

  onClick() {
    this.clicked.emit(this.rowData);
  }
  onResendClick() {
    this.resendclicked.emit(this.rowData);
  }

}
